__turbopack_context__.v({
  "app_light_theme": "discount-list-module-scss-module__FuJJDa__app_light_theme",
  "inner": "discount-list-module-scss-module__FuJJDa__inner",
  "inner__open": "discount-list-module-scss-module__FuJJDa__inner__open",
  "item": "discount-list-module-scss-module__FuJJDa__item",
  "list": "discount-list-module-scss-module__FuJJDa__list",
  "topPanel": "discount-list-module-scss-module__FuJJDa__topPanel",
});
